"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _OfficerModule = _interopRequireDefault(require("./Officer.module.css"));

var staticImages = _interopRequireWildcard(require("../staticImages"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var Officer = /*#__PURE__*/function (_React$Component) {
  _inherits(Officer, _React$Component);

  var _super = _createSuper(Officer);

  function Officer(props) {
    var _this;

    _classCallCheck(this, Officer);

    _this = _super.call(this, props);
    _this.state = {
      initials: ""
    };
    _this.openCalendly = _this.openCalendly.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Officer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var words = this.props.name.split(" ");
      var first = "";

      if (words[0] !== undefined) {
        first = words[0][0];
      }

      var second = "";

      if (words[1] !== undefined) {
        second = words[1][0];
      }

      this.setState({
        initials: first + second
      });
    }
  }, {
    key: "openCalendly",
    value: function openCalendly() {
      if (this.props.calendly.toLowerCase().includes("https://")) {
        window.open(this.props.calendly, "_blank");
      } else {
        window.open("https://".concat(this.props.calendly), "_blank");
      }
    }
  }, {
    key: "render",
    value: function render() {
      var fontSize = '10px';
      var fontSize2 = '7px';

      if (window.innerWidth >= 768 && window.innerWidth <= 1149) {
        fontSize = '6px';
        fontSize2 = '6px';
      }

      return /*#__PURE__*/_react["default"].createElement("div", {
        id: _OfficerModule["default"].card
      }, /*#__PURE__*/_react["default"].createElement("div", {
        id: _OfficerModule["default"].circle,
        style: {
          background: this.props.color
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        id: _OfficerModule["default"].initial
      }, this.state.initials)), /*#__PURE__*/_react["default"].createElement("div", {
        id: _OfficerModule["default"].name,
        style: {
          fontSize: fontSize
        }
      }, this.props.name), /*#__PURE__*/_react["default"].createElement("div", {
        id: _OfficerModule["default"].title,
        style: {
          fontSize: fontSize2
        }
      }, this.props.title.toUpperCase()), this.props.calendly === undefined ? "" : /*#__PURE__*/_react["default"].createElement("img", {
        id: _OfficerModule["default"].calendly,
        onClick: this.openCalendly,
        alt: "calendly button",
        src: staticImages.CALENDLY,
        style: {
          zIndex: 10,
          cursor: "pointer"
        }
      }));
    }
  }]);

  return Officer;
}(_react["default"].Component);

var _default = Officer;
exports["default"] = _default;

//# sourceMappingURL=Officer.js.map